function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientTransform: "matrix(0 -1 -1 0 -569.6 -3194.99)",
  gradientUnits: "userSpaceOnUse",
  x1: -3191.373,
  x2: -3675.829,
  y1: -1481.861,
  y2: -127.465
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff3ee",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2938,
  stopColor: "#ffeade",
  stopOpacity: 0.373
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7874,
  stopColor: "#ffd6bb"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 252.146,
  x2: 252.146,
  y1: 388.611,
  y2: 154.671
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff4d4d",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff4d4d",
  stopOpacity: 0
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m180.252.001c-100.63.534-151.151 173.599-170.006 262.559-18.855 88.961.847 271.458 147.096 247.249 23.64-3.913 29.158-4.715 48.645-14.497 34.685-17.411 75.734-29.661 112.83-33.359 15.211-1.516 34.445-6.538 44.624-8.368 81.626-14.679 164.928-93.76 139.709-176.622-18.939-62.228-74.428-87.278-129.998-83.834-30.518 1.891-62.997-16.011-69.51-35.788-21.214-64.417-45.612-157.752-123.39-157.34z",
  fill: "url(#SVGID_1_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m448.185 169.671v203.94c0 8.29-6.71 15-15 15h-362.08c-8.29 0-15-6.71-15-15v-203.94c0-8.29 6.71-15 15-15h362.08c8.29 0 15 6.71 15 15z",
  fill: "#b3b3ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m415.145 154.671v210.18c0 5.52-4.48 10-10 10h-143c-2.76 0-5.26-1.12-7.07-2.93s-2.93-4.31-2.93-7.07c0 5.52-4.48 10-10 10h-143c-5.52 0-10-4.48-10-10v-210.18z",
  fill: "#9494ff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m448.187 342.217h-392.086v-172.548c0-8.284 6.716-15 15-15h362.086c8.284 0 15 6.716 15 15z",
  fill: "#ff6c6c"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m252.145 157.881v189.42c0 5.52-4.48 10-10 10h-143c-5.52 0-10-4.48-10-10v-204.42c0-5.52 4.48-10 10-10h128c13.81 0 25 11.19 25 25z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m185.31 329.782h-29.333c-5.523 0-10-4.477-10-10v-195.811c0-4.711 1.663-9.272 4.697-12.877l16.144-19.187c1.998-2.374 5.654-2.374 7.652 0l16.144 19.187c3.033 3.605 4.697 8.165 4.697 12.877v195.811c-.001 5.523-4.478 10-10.001 10z",
  fill: "#f7f3ff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m227.57 290.734h-113.282c-2.762 0-5-2.239-5-5s2.238-5 5-5h113.282c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#b3b3ff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m227.57 310.236h-113.282c-2.762 0-5-2.239-5-5s2.238-5 5-5h113.282c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#b3b3ff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m232.57 324.74c0 2.76-2.24 5-5 5h-113.28c-2.76 0-5-2.24-5-5s2.24-5 5-5h113.28c2.76 0 5 2.24 5 5z",
  fill: "#b3b3ff"
})), /*#__PURE__*/React.createElement("path", {
  d: "m195.31 319.74v.04c0 5.22-4 9.51-9.11 9.96-.29.03-.59.04-.89.04h-29.33c-.3 0-.6-.01-.89-.04-5.11-.45-9.11-4.74-9.11-9.96v-.04z",
  fill: "#9494ff"
}))), /*#__PURE__*/React.createElement("path", {
  d: "m227 265.783h-112.712c-2.761 0-5-2.239-5-5v-101.657c0-2.761 2.239-5 5-5h112.712c2.761 0 5 2.239 5 5v101.656c0 2.762-2.239 5.001-5 5.001z",
  fill: "#ff9494"
}), /*#__PURE__*/React.createElement("path", {
  d: "m262.145 357.301h142.999c5.523 0 10-4.477 10-10v-204.418c0-5.523-4.477-10-10-10h-127.999c-13.807 0-25 11.193-25 25v189.418c0 5.523 4.477 10 10 10z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ffc599"
}, /*#__PURE__*/React.createElement("path", {
  d: "m252.145 281v66.301c0 5.523 4.477 10 10 10h142.999c5.523 0 10-4.477 10-10v-66.301z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m395 204v-44.874c0-2.761-2.239-5-5-5h-112.712c-2.761 0-5 2.239-5 5v44.874c0 2.761 2.239 5 5 5h112.712c2.761 0 5-2.239 5-5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m327.008 247.382h-49.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h49.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#8383ff"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m354.008 264.885h-76.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h76.52c2.762 0 5 2.239 5 5s-2.238 5-5 5z",
  fill: "#8383ff"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "#8383ff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 279.036,
  cy: 224.332,
  r: 5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 295.286,
  cy: 224.332,
  r: 5
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 215.036,
  cy: 171.333,
  fill: "#fff",
  r: 5
})), /*#__PURE__*/React.createElement("path", {
  d: "m448.185 169.671v203.94c0 8.29-6.71 15-15 15h-362.08c-8.29 0-15-6.71-15-15v-203.94c0-8.29 6.71-15 15-15h362.08c8.29 0 15 6.71 15 15z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m431.144 450.784c-1.28 0-2.559-.488-3.536-1.464l-4.464-4.464-4.464 4.464c-1.953 1.952-5.118 1.952-7.071 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.953-1.952 5.118-1.952 7.071 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.977.976-2.257 1.464-3.536 1.464z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m97.145 110.518c-1.28 0-2.559-.488-3.536-1.464l-4.464-4.464-4.464 4.464c-1.953 1.952-5.118 1.952-7.071 0-1.953-1.953-1.953-5.119 0-7.071l8-8c1.953-1.952 5.118-1.952 7.071 0l8 8c1.953 1.953 1.953 5.119 0 7.071-.977.976-2.257 1.464-3.536 1.464z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m117.29 55.667h-3v-3c0-2.761-2.239-5-5-5s-5 2.239-5 5v3h-3c-2.761 0-5 2.239-5 5s2.239 5 5 5h3v3c0 2.761 2.239 5 5 5s5-2.239 5-5v-3h3c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m341.644 85.127h-3v-3c0-2.761-2.239-5-5-5s-5 2.239-5 5v3h-3c-2.761 0-5 2.239-5 5s2.239 5 5 5h3v3c0 2.761 2.239 5 5 5s5-2.239 5-5v-3h3c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m382 461.174h-3v-3c0-2.761-2.239-5-5-5s-5 2.239-5 5v3h-3c-2.761 0-5 2.239-5 5s2.239 5 5 5h3v3c0 2.761 2.239 5 5 5s5-2.239 5-5v-3h3c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m386.163 409.204h-105.074c-2.761 0-5-2.239-5-5v-93.805c0-2.761 115.074-2.761 115.074 0v93.805c0 2.761-2.239 5-5 5z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m391.163 334.084v-23.685c0-2.761-2.239-5-5-5h-105.074c-2.761 0-5 2.239-5 5v23.685z",
  fill: "#ffc599"
})), /*#__PURE__*/React.createElement("path", {
  d: "m320.213 355.643v24.317c0 2.316 2.513 3.758 4.513 2.591l20.825-12.159c1.983-1.158 1.983-4.024 0-5.182l-20.825-12.159c-2-1.167-4.513.276-4.513 2.592z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 295.478,
  cy: 322.75,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 306.645,
  cy: 322.75,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 317.811,
  cy: 322.75,
  r: 3.5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m185.31 308.754h-29.333c-5.523 0-10-4.477-10-10v-195.811c0-4.711 1.663-9.272 4.697-12.877l16.144-19.187c1.998-2.374 5.654-2.374 7.652 0l16.144 19.187c3.033 3.605 4.697 8.165 4.697 12.877v195.811c-.001 5.523-4.478 10-10.001 10z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m161.894 101.518h17.5v207.236h-17.5z",
  fill: "#d9d9ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m195.31 102.943c0-4.711-1.663-9.272-4.697-12.877l-16.143-19.186c-1.998-2.375-5.654-2.375-7.652 0l-16.144 19.187c-3.033 3.605-4.697 8.165-4.697 12.877z",
  fill: "#ffd9d9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m188.594 87.667-14.124-16.787c-1.998-2.375-5.654-2.375-7.652 0l-14.124 16.786z",
  fill: "#4d4dff"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m239.545 357.301v54.81c0 4.02-4.5 6.39-7.82 4.13l-13.31-9.07-13.31 9.07c-3.32 2.26-7.82-.11-7.82-4.13v-54.81z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m197.285 357.301h42.26v17.55h-42.26z",
  fill: "#ff4d4d"
})))));

function SvgDiscoverCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCourse);
export default __webpack_public_path__ + "static/media/discover-course.5e8146d3.svg";
export { ForwardRef as ReactComponent };